
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddCalculationitemForSaleDtoFormGroup() {
return new FormGroup({
    projectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    itemId: new FormControl<number | undefined>(undefined, [Validators.required]),
    targetAmount: new FormControl<number | undefined>(1, [Validators.min(0)]),
})
;
}
      